import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { getCommentCount } from '@Container/common/client/services/api';

class Caption extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        allowComment: false,
        joinNum: 0,
        count: 0,
    };

    async componentDidMount() {
        const { commentUrl } = this.props.content;

        try {
            const { count, join_count, allow_comment } = await getCommentCount(commentUrl);

            this.setState({
                allowComment: allow_comment !== -1,
                joinNum: join_count,
                count,
            });
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { allowComment, joinNum, count } = this.state;
        const { content } = this.props;
        const { base62Id, title, newsTime, fhhAccountDetail, source, sourceUrl } = content;
        const followUrl = `//gentie.ifeng.com/c/comment/${base62Id}`;

        const props =
            !fhhAccountDetail.forbidJump && fhhAccountDetail.authorUrl
                ? {
                      href: fhhAccountDetail.authorUrl,
                      target: '_blank',
                  }
                : {};

        return (
            <div className={styles.caption}>
                <h1 className={styles.topic}>{title}</h1>
                <p>
                    <span className={styles.date}>{newsTime}</span>
                    {!fhhAccountDetail.catename ? (
                        <span className={styles.source}>
                            {fhhAccountDetail.authorUrl ? (
                                <a href={fhhAccountDetail.authorUrl} target="_blank">
                                    {fhhAccountDetail.catename}
                                </a>
                            ) : (
                                <span>{fhhAccountDetail.catename}</span>
                            )}
                        </span>
                    ) : (
                        <span className={styles.source}>
                            <a {...props}>{fhhAccountDetail.catename}</a>
                        </span>
                    )}
                </p>
                {allowComment ? (
                    <div className={styles.comment_box}>
                        <h5 className={styles.comment}>
                            <a className={styles.joinNum} href={followUrl} target="_blank">
                                <span className={styles.num}>{joinNum}</span>
                                <span className={styles.text}>人参与</span>
                            </a>
                            <a className={styles.commentNum} href={followUrl} target="_blank">
                                <span className={styles.num}>{count}</span>
                                <span className={styles.text}>评论</span>
                            </a>
                        </h5>
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(Caption);
